import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "q-mb-md"
}
const _hoisted_2 = {
  key: 1,
  class: "q-mb-md"
}

import { computed, ref, watch } from "vue";
import {
  appStore,
  artifactGenerationApiStore,
  artifactStore,
  selectionStore,
  timStore,
} from "@/hooks";
import {
  DetailsPanel,
  PanelCard,
  FlexBox,
  TextButton,
  ArtifactInput,
  ArtifactTypeInput,
} from "@/components/common";


/**
 * Displays inputs for summarizing artifacts.
 */
const __default__ = {
  name: "ArtifactSummarizationPanel",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const mode = ref<"single" | "multiple">("single");
const artifactIds = ref<string[]>([]);
const artifactTypes = ref<string[]>([]);

const canGenerate = computed(() => {
  if (mode.value === "single") {
    return artifactIds.value.length > 0;
  } else {
    return artifactTypes.value.length > 0;
  }
});

/**
 * Returns props for a mode button.
 * @param option - The mode button to get props for.
 */
function buttonProps(option: "single" | "multiple") {
  const selected = mode.value === option;

  return {
    text: !selected,
    color: selected ? undefined : "text",
    class: selected ? "button-group-selected text-primary" : "",
  };
}

/**
 * Clears all input fields.
 */
function handleReset(): void {
  if (selectionStore.selectedGroupIds.length > 0) {
    mode.value = "single";
    artifactIds.value = selectionStore.selectedGroupIds;
    artifactTypes.value = [];
  } else if (timStore.selectedArtifactLevel) {
    mode.value = "multiple";
    artifactTypes.value = [timStore.selectedArtifactLevel.name];
    artifactIds.value = [];
  } else {
    mode.value = "single";
    artifactIds.value = [];
    artifactTypes.value = [];
  }
}

/**
 * Generates new parent artifacts based on inputted child artifacts.
 */
function handleGenerate(): void {
  const ids: string[] =
    mode.value === "single"
      ? artifactIds.value
      : artifactTypes.value
          .map((type) => artifactStore.getArtifactsByType(type))
          .flatMap<string, string[]>(
            (artifacts) => artifacts.map(({ id }) => id),
            []
          );

  artifactGenerationApiStore.handleGenerateAllSummaries(ids, {
    onSuccess: () => {
      handleReset();
      appStore.closeSidePanels();
    },
  });
}

watch(
  () => appStore.popups.detailsPanel === "summarizeArtifact",
  (openState) => {
    if (!openState) return;

    handleReset();
  }
);

return (_ctx: any,_cache: any) => {
  const _component_q_btn_group = _resolveComponent("q-btn-group")!

  return (_openBlock(), _createBlock(_unref(DetailsPanel), { panel: "summarizeArtifact" }, {
    default: _withCtx(() => [
      _createVNode(_unref(PanelCard), {
        title: "Generate Summaries",
        borderless: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_btn_group, {
            flat: "",
            class: "q-mb-md"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(TextButton), _mergeProps(buttonProps('single'), {
                label: "Artifacts",
                icon: "artifact",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (mode.value = 'single'))
              }), null, 16),
              _createVNode(_unref(TextButton), _mergeProps(buttonProps('multiple'), {
                label: "Artifact Types",
                icon: "view-tim",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (mode.value = 'multiple'))
              }), null, 16)
            ]),
            _: 1
          }),
          (mode.value === 'single')
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(ArtifactInput), {
                  modelValue: artifactIds.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((artifactIds).value = $event)),
                  multiple: "",
                  label: "Artifacts",
                  hint: "Summarize the contents of each artifact listed."
                }, null, 8, ["modelValue"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_unref(ArtifactTypeInput), {
                  modelValue: artifactTypes.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((artifactTypes).value = $event)),
                  multiple: "",
                  label: "Artifact Types",
                  hint: "Summarize the contents of all artifacts of the selected types."
                }, null, 8, ["modelValue"])
              ])),
          _createVNode(_unref(FlexBox), {
            "full-width": "",
            justify: "end",
            t: "3"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(TextButton), {
                disabled: !canGenerate.value,
                loading: _unref(artifactGenerationApiStore).artifactGenLoading,
                label: "Generate",
                color: "primary",
                onClick: handleGenerate
              }, null, 8, ["disabled", "loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})